// Wires a click ("drill") handler onto the geography "leads by province"
// Chartkick chart. Clicking a state bar opens the lead drill scoped to that
// state. The poller retries wiring until the chart is ready, since the chart
// may render after this script runs.

export const CHART_ID = 'leads_by_province_chart_inner';
export const ORIGIN = 'geography';
export const ANCHOR = 'geography-top-states';

function onClick(event, elements, chart) {
  if (typeof window.leadDrill !== 'function') {
    return;
  }

  const hit = (elements && elements.length)
    ? elements
    : chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

  if (!hit.length) {
    return;
  }

  const state = chart.data.labels[hit[0].index];
  if (state === null || state === undefined || state === '') {
    return;
  }

  window.leadDrill({ state: state }, { origin: ORIGIN, anchor: ANCHOR });
}

export function wireGeographyTopStatesDrill() {
  if (!window.Chartkick) {
    return false;
  }

  const charts = window.Chartkick.charts;
  const chart = charts && charts[CHART_ID];
  if (!chart) {
    return false;
  }

  if (typeof chart.getChartObject !== 'function') {
    return false;
  }

  const cjs = chart.getChartObject();
  if (!cjs) {
    return false;
  }

  cjs.options.onClick = onClick;
  if (cjs.scales && cjs.scales.y && cjs.scales.y.options && cjs.scales.y.options.ticks) {
    cjs.scales.y.options.ticks.autoSkip = false;
  }
  if (cjs.options && cjs.options.scales && cjs.options.scales.y && cjs.options.scales.y.ticks) {
    cjs.options.scales.y.ticks.autoSkip = false;
  }
  if (typeof cjs.update === 'function') {
    cjs.update('none');
  }
  return true;
}

export function startGeographyTopStatesDrillPoll() {
  if (window.__geographyTopStatesDrillPoll) {
    clearInterval(window.__geographyTopStatesDrillPoll);
    window.__geographyTopStatesDrillPoll = null;
  }

  if (wireGeographyTopStatesDrill()) {
    return;
  }

  let attempts = 0;
  window.__geographyTopStatesDrillPoll = setInterval(function () {
    attempts += 1;
    if (wireGeographyTopStatesDrill() || attempts >= 40) {
      clearInterval(window.__geographyTopStatesDrillPoll);
      window.__geographyTopStatesDrillPoll = null;
    }
  }, 150);
}

// Window bridge: the inline ERB cannot import this module, so it reaches the
// entry points through these globals.
if (typeof window !== 'undefined') {
  window.reportsWireGeographyTopStatesDrill = wireGeographyTopStatesDrill;
  window.reportsStartGeographyTopStatesDrillPoll = startGeographyTopStatesDrillPoll;
}
